import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import dashboard from '../../publisher/dashboard/dashboard';
import { MerchTopPublisherMegatable } from '../../merchant/megatable/megatable-extensions';

const Dashboard = withLDConsumer()(dashboard);
const TopPublisherMegatable = withLDConsumer()(MerchTopPublisherMegatable);

export { Dashboard, TopPublisherMegatable };
